import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {HttpClient} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SelectionModel} from '@angular/cdk/collections';
import {MatPaginator} from '@angular/material/paginator';
import * as _ from 'lodash';
import {saveAs} from 'file-saver';
import {environment} from 'src/environments/environment';

export interface SARList {
  customer_name: string;
  caseId: number;
  sarId: number;
  created_at: Date;
  sar_name: string;
  select: boolean;
  customer_id: string,
  file_type: string,
  download_url: string,
  sar_id: string,
  case_code: string,
  customer_img: string
}

@Component({
  selector: 'app-sar',
  templateUrl: './sar.component.html',
  styleUrls: ['./sar.component.scss']
})
export class SarComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['customer_name', 'case_code', 'sar_id', 'created_at', 'sar_name'];
  SARData: any;
  dataSource: any;
  selection: any;
  isDownloadDisabled = true;
  serverUrl = environment.serverUrl;
  rowsOnPage = 8;

  constructor(private httpClient: HttpClient, private snackBar: MatSnackBar) {
  }

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngAfterViewInit() {
    this.fetchSarList();
  }

  ngOnInit() {
    this.rowsOnPage = Math.floor((document.getElementsByClassName('container_table')[0].clientHeight - 112) / 48);
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }


  fetchSarList() {
    this.httpClient.get<SARList>(this.serverUrl + '/transaction/sar_list/')
      .subscribe(
        (response: any) => {
          this.SARData = response.data_info.sar_list;
          this.dataSource = new MatTableDataSource(this.SARData);
          this.dataSource.paginator = this.paginator;
          this.selection = new SelectionModel<SARList>(true, []);
          this.formatDate(this.dataSource.data);
          this.dataSource.sort = this.sort;
        },
        (error) => {
          this.snackBar.open(error.error.error, 'close', {
            duration: 4000
          });
        }
      );
  }

  formatDate(data) {
    _.forEach(data, (item) => {
      item.created_at = new Date(item.created_at);
    });
  }

  download(item) {
      this.httpClient.get(this.serverUrl + '/transaction/' + item.download_url, {responseType: 'blob' as 'json'}).subscribe(
        (response: Blob) => {
          const blob = new Blob([response], {type: response.type});
          const url = window.URL.createObjectURL(blob);
          saveAs(blob, item.case_code + '.doc');      
        },
        (error) => {
        }
      );
  }

  downloadMultiple() {
    const collection = this.selection.selected;
    const promises = _.forEach(collection, (row) => {
      this.download(row);

    });

    Promise.all(promises).then(
      (result) => {
        this.selection.clear();
      }
    );

  }
}
